var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('h1',{staticClass:"text-text2 heading-2"},[_vm._v("Shipworks 90 Days")])])
}]

export { render, staticRenderFns }